<template>
  <div>

    <v-card class="blue lighten-4" elevation="0" v-if="$store.state.hotSpots.length > 0">
      <v-fab-transition>
<!--        <v-btn small color="purple" dark top left fab absolute style="transform: translateY(-5px);" @click="addHotspotDialogVisible=true" v-if="drawerOpen">-->
        <v-btn small color="purple" dark top left fab absolute style="transform: translateY(-5px);" @click="addHotspotDialogVisible=true">
          <v-icon>mdi-heart</v-icon>
        </v-btn>
      </v-fab-transition>
      <v-list class="blue lighten-4">
        <v-list-item v-for="place in $store.state.hotSpots" :key="place.place_id" >
          <v-list-item-content style="justify-content: center">
            <v-list-item-title @click="centerToHotspot(place.place_id, place.name)" style="word-wrap: break-word; overflow-wrap: break-word; max-width: 90vw; white-space: pre-wrap;">{{ place.name }}</v-list-item-title>
            <v-list-item-subtitle @click="centerToHotspot(place.place_id, place.name)">
              <v-rating
                  v-model="place.rating"
                  background-color="purple lighten-3"
                  color="orange"
                  small
                  half-increments
                  dense
                  readonly
              ></v-rating>
              {{ place.rating }} Rating ({{ place.user_ratings_total }} Reviews)
            </v-list-item-subtitle>
            <v-list-item-subtitle v-if="store.state.userHotspotLikes.includes(place.place_id)" style="white-space: pre-wrap">{{ likesDict[place.place_id] || 0 }}
              <v-icon color="red" @click="unlike_hotspot(place.place_id)">mdi-heart</v-icon></v-list-item-subtitle>
            <v-list-item-subtitle v-else style="white-space: pre-wrap">{{ likesDict[place.place_id] || 0 }}
              <v-icon @click="like_hotspot(place)">mdi-heart-outline</v-icon></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
      </v-list>
    </v-card>
    <v-card class="blue lighten-4" elevation="0" v-else-if="store.state.userData.currentStayLocation">
      <v-fab-transition>
<!--        <v-btn small color="purple" dark top left fab absolute style="transform: translateY(-5px);" @click="addHotspotDialogVisible=true" v-if="drawerOpen">-->
        <v-btn small color="purple" dark top left fab absolute style="transform: translateY(-5px);" @click="addHotspotDialogVisible=true">
          <v-icon>mdi-heart</v-icon>
        </v-btn>
      </v-fab-transition>
      <v-list class="blue lighten-4">
        <v-list-item>
          <v-list-item-content>
<!--            <v-list-item-title>Couldn't Find Nomadic Places Near</v-list-item-title>-->
<!--            <v-list-item-title>This Area</v-list-item-title>-->
            <v-list-item-title>No Recommendations Around You Yet</v-list-item-title>
<!--            <v-list-item-title><v-icon>mdi-emoticon-sad-outline</v-icon></v-list-item-title>-->
            <v-list-item-title style="text-wrap: pretty" class="mt-5">Share <strong>Your</strong> Favorite Place With the Community</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
      </v-list>
    </v-card>
    <v-card class="blue lighten-4" elevation="0" v-else>
      <v-list class="blue lighten-4">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Let Us Know Where You Are</v-list-item-title>
            <v-list-item-title>To Find Nomad's Recommendations Around You</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
      </v-list>
    </v-card>
    <v-dialog v-model="addHotspotDialogVisible" max-width="600px" class="my-16">
      <AddHotspot @closeAddHotspotDialog="closeAddHotspotDialog" @update_likes_dict="update_likes_dict" @getNomadsHotSpots="getNomadsHotSpots"></AddHotspot>
    </v-dialog>
    <div ref="map"></div>
  </div>
</template>

<script>
import {gmapApi} from "vue2-google-maps";
import {store} from "@/store";
import supabase from "@/lib/supabaseClient";
import AddHotspot from "@/components/AddHotspot.vue";

export default {
  name: 'HotSpots',
  components: {AddHotspot},
  props: ['mapObject', 'drawerOpen'],
  data: () => ({
    searchLocation: store.state.userData.currentStayPosition,
    searchRadiusInMeters: 2000,
    mapCenter: store.state.viewsMapCenter[2],
    mapZoom: store.state.viewsMapZoom[2],
    likesDict: {},
    addHotspotDialogVisible: false,
  }),
  computed: {
    store() {
      return store
    },
    google() {
      return gmapApi && window.google ? window.google : null;
    },
    getCurrentMapBounds() {
      return store.state.currentMapBounds;
    },
    getCurrentHotspotType() {
      return store.state.hotspotType;
    },
  },
  async mounted() {

    if (store.state.viewsMapCenter[2]) {
      while (!this.mapObject.getBounds().contains(store.state.viewsMapCenter[2])) {
        await new Promise(resolve => setTimeout(resolve, 100)); // wait for 100ms before checking again
        console.log('waiting for map to load')
      }
      await this.getCenterAndRadius();
    } else if (store.state.userData.currentStayLocation) {
      while (!this.mapObject.getBounds().contains(store.state.userData.currentStayPosition)) {
        await new Promise(resolve => setTimeout(resolve, 100)); // wait for 100ms before checking again
        console.log('waiting for map to load')
      }
      await this.getCenterAndRadius();
    }

    this.update_likes_dict()
  },
  watch: {
    getCurrentHotspotType: {
      handler: async function (newVal) {
        if (newVal) {
          store.commit('getHotSpots', []);
          this.$emit('closeInfoWindow')
          await this.getCenterAndRadius()
        }
      }
    },
    // 'store.state.currentMapBounds': {
    //   handler: async function (newVal) {
    //     if (newVal && store.state.hotSpots) {
    //       await this.getCenterAndRadius()
    //     }
    //   }
    // },
    getCurrentMapBounds: {
      handler: async function () {
        await this.getCenterAndRadius()
      }
    },
  },

  methods: {
    closeAddHotspotDialog() {
      this.addHotspotDialogVisible = false
    },
    update_likes_dict() {
      this.likesDict = store.state.likedHotspots.reduce((acc, curr) => {
        acc[curr.place_id] = curr.likes
        return acc
      }, {})
    },

    async getCenterAndRadius() {
      await this.getHotSpots()
    },
    centerToHotspot(placeId) {
      const place = store.state.hotSpots.find(place => place.place_id === placeId);
      console.log(place)
      store.commit('changeMapCenter', place.geometry.location);
      this.$emit('hotspotClick', place);

    },
    closeAndDestroy() {
      store.commit('pickHotspotType', null)
      store.commit('getHotSpots', []);
      this.$destroy()
    },
    openInGoogleMaps(placeId, placeName) {
      const url = `https://www.google.com/maps/search/?api=1&query=${placeName}&query_place_id=${placeId}`;
      window.open(url, '_blank');
    },

    async checkRowExistence(idToCheck) {
      const { count, error } = await supabase
          .from('hotspots')
          .select('*', { count: 'exact', head: true })
          .eq('id', idToCheck);
      if (error) {
        console.error('Error checking row existence:', error);
        return false; // Handle the error as needed
      }
      return count >= 1;
    },

    async create_hotspot_in_db(place) {
      const alreadyExists = await this.checkRowExistence(place.place_id)
      if (alreadyExists) {
        console.log('location exists')
        return true
      }
      const { data, error } = await supabase
          .from('hotspots')
          .insert([
            { id: place.place_id, name: place.name, rating: place.rating, user_ratings_total: place.user_ratings_total, position: place.geometry.location, types: place.types},
          ])
          .select()
      if (error) {
        console.log(error)
      } else {
        console.log(data)
        return true
      }
    },

    async like_hotspot(place) {
      await this.create_hotspot_in_db(place)
      const { data, error } = await supabase
          .from('hotspot_likes')
          .insert([
            { id: store.state.userData.userId + '_' + place.place_id, user_id: store.state.userData.userId, google_place_id: place.place_id },
          ])
          .select()
      if (error) {
        console.log(error)
      } else {
        console.log(data)
        await store.dispatch('getUserLikes')
        await store.dispatch('getLikedHotspots')
        await this.getNomadsHotSpots()
        this.update_likes_dict()
      }
    },
    async unlike_hotspot(placeId) {
      const { data, error } = await supabase
          .from('hotspot_likes')
          .delete()
          .match({ id: store.state.userData.userId + '_' + placeId })
      if (error) {
        console.log(error)
      } else {
        console.log(data)
        await store.dispatch('getUserLikes')
        await store.dispatch('getLikedHotspots')
        await this.getNomadsHotSpots()
        this.update_likes_dict()
      }
    },

    async getHotSpots() {
      if (store.state.hotspotType === 'nomads choice') {
        await this.getNomadsHotSpots()
      } else {
        await this.getGoogleHotSpots()
      }
      console.log(store.state.hotSpots)
    },
    getNomadsHotSpots() {
      console.log(store.state.likedHotspots)
      let filteredHotspots = store.state.likedHotspots.filter(hotSpot => {
        return this.mapObject.getBounds().contains(hotSpot.geometry.location);
      });

      store.commit('getHotSpots', filteredHotspots);
    },
    async getGoogleHotSpots() {
      const keywords = [store.state.hotspotType];

      let allResults = [];

      const uniquePlaceIds = new Set();

      try {
        const service = new this.google.maps.places.PlacesService(this.mapObject);

        const searchPlaces = (keyword) => {
          return new Promise((resolve, reject) => {
            // const request = { location, radius, keyword };
            let searchMapBounds = this.mapObject.getBounds()
            const request = {
              // bounds: store.state.currentMapBounds,
              bounds: searchMapBounds,
              keyword,
            }
            service.nearbySearch(request, (results, status) => {
              if (status === this.google.maps.places.PlacesServiceStatus.OK) {
                resolve(results);
              } else {
                reject(`Error fetching nearby places for ${keyword}: ${status}`);
              }
            });
          });
        };

        for (const keyword of keywords) {
          try {
            const results = await searchPlaces(keyword);
            const filteredResults = results
                .filter(place => place.user_ratings_total >= 10)
                .filter(place => {
                  if (uniquePlaceIds.has(place.place_id)) {
                    return false;
                  } else {
                    uniquePlaceIds.add(place.place_id);
                    return true;
                  }
                });
            allResults.push(...filteredResults);
          } catch (error) {
            console.error(error);
          }
        }
        let allResultsPlaceIds = allResults.map(item => item.place_id)
        store.state.hotSpots.forEach(item => {
          if (!allResultsPlaceIds.includes(item.place_id)) {
            allResults.push(item)
          }
        })

        allResults.unshift(...store.state.likedHotspots)

        let filteredHotspots = allResults.filter(hotSpot => {
          return this.mapObject.getBounds().contains(hotSpot.geometry.location);
        });

        // remove duplicates location by place_id in filteredHotspots
        filteredHotspots = filteredHotspots.filter((v,i,a)=>a.findIndex(t=>(t.place_id === v.place_id))===i)

        store.commit('getHotSpots', filteredHotspots);
      } catch (error) {
        console.error('Error in getHotSpots method:', error);
      }
    }
  },
}
</script>

<style >
  .drawerTitle {
    padding-top: 0;
    padding-bottom: 20px;
  }
</style>
